(function() {

  'use strict';

  function Orcamento($q, OrcamentoResource) {

    var Orcamento = {};

    // solicita a lista de endereços
    Orcamento.getOrcamento = function(dadosEntrada, callback) {
      var cb = callback || angular.noop;
      var deferred = $q.defer();

      OrcamentoResource.postOrcamento(dadosEntrada).$promise
        .then(function(data) {
          deferred.resolve(data);
          return cb(data);
        })
        .catch(function(err) {
          deferred.reject(err);
          return cb(err);
        }.bind(this));

      return deferred.promise;

    };

    return Orcamento;

  };

  angular.module('mandaeApp')
    .factory('Orcamento', Orcamento);

})();
